<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-md rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-xl font-bold text-text-main">
          Datei bewegen
        </h2>
        <div class="mb-6">
          <label class="block text-sm font-bold text-text-main mb-2">Zielordner für {{ file }}:</label>
          <select
            v-model="selectedFolderId"
            class="w-full rounded-standard border border-tertiary bg-primary px-3 py-2 text-sm text-text-main outline-none focus:border-accent"
          >
            <option
              disabled
              value=""
            >
              Ordner auswählen …
            </option>
            <optgroup
              v-for="project in projects"
              :key="project.id"
              :label="project.name"
            >
              <option
                v-for="folder in project.folders"
                :key="folder.id"
                :value="folder.id"
              >
                {{ folder.name }}
              </option>
            </optgroup>
          </select>
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="cursor-pointer rounded-standard bg-accent px-6 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="submit"
          >
            Speichern
          </button>

          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

type Folder = {
  id: string
  name: string
  files: string[]
}

type Project = {
  id: string
  name: string
  folders: Folder[]
}

const props = defineProps<{
  isOpen: boolean
  file: string
  projects: Project[]
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'save', newFolderId: string): void
}>()

const selectedFolderId = ref('')

watch(
  () => props.isOpen,
  (newVal) => {
    if (newVal) {
      selectedFolderId.value = ''
    }
  }
)

function submit() {
  if (selectedFolderId.value) {
    emit('save', selectedFolderId.value)
  }
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
